import {useEffect,useState} from 'react';
import {doc,onSnapshot} from 'firebase/firestore';
import {db} from '../../firebase';
export default function useTenantTimeZone(tenantId){
 const [value,setValue]=useState(null);
 useEffect(()=>{setValue(null);if(!tenantId||tenantId==='all')return;return onSnapshot(doc(db,'tenants',tenantId),snap=>{const zone=snap.data()?.timeZone||snap.data()?.timezone;try{new Intl.DateTimeFormat('en-US',{timeZone:zone}).format();setValue(zone?{tenantId,zone}:null);}catch{setValue(null);}},()=>setValue(null));},[tenantId]);
 return value && value.tenantId===tenantId?value.zone:null;
}
